import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { apiMessageQueries } from '@/services/apiMessage/apiMessage.queries';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

export const useUpdateApiMessage = () => {
  const queryClient = useQueryClient();
  const { mutateAsync, isPending } = useMutation('updateApiMessage', {
    onSuccess: async (res) => {
      toast.success(res.message);
      await queryClient.invalidateQueries({ queryKey: apiMessageQueries.all() });
    },
    onError: (err) => {
      toast.error(err.message);
    },
  });

  return { mutateAsync, isPending };
};
